module.exports = __webpack_public_path__ + "static/media/addnewbook.90c8d0ef.svg";